import { render, staticRenderFns } from "./createMannual.vue?vue&type=template&id=14bb10ff&scoped=true"
import script from "./createMannual.vue?vue&type=script&lang=js"
export * from "./createMannual.vue?vue&type=script&lang=js"
import style0 from "./createMannual.vue?vue&type=style&index=0&id=14bb10ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bb10ff",
  null
  
)

export default component.exports